import styled from "styled-components";
import * as TypographyStyles from '../TypographyStyles';
import { colors } from "../../utils/colors";
import { purpleColors } from '../ContentPages/AppLandingPage/styles';
import { useTranslation } from 'react-i18next';

const Container = styled('div')`
  display: flex;
  grid-column-gap: 8px;
  justify-content: space-between;
  width: 100%;
`

const DotWrapper = styled('div')<{ $cancelled?: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  margin-right: 12px;
  
  &::after {
    content: "";
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${props => props.$cancelled ? colors.red : purpleColors[500]};
    border: 2px solid white;
    box-sizing: border-box;
  }
`

const Name = styled('div')`
  display: flex;
  margin-left: -32px;
  align-items: center;
  position: relative;
  z-index: 1;
  & > img {
    display: none;
  }
`

type LocationProps = {
  name: string;
  platform?: string;
  plannedPlatform?: string;
  cancelled?: boolean;
}

const Location = ({ name, platform, plannedPlatform, cancelled = false }: LocationProps) => {
  const { t } = useTranslation();
  const platformToShow = platform ? platform : plannedPlatform;
  const platformHasChanged = platform ? platform !== plannedPlatform : false;
  return (
    <Container>
      <Name>
        <DotWrapper $cancelled={cancelled} />
        <TypographyStyles.BodyLBold color={colors.black}>{name}</TypographyStyles.BodyLBold>
      </Name>
      {platformToShow && 
      <TypographyStyles.BodyMRegular color={platformHasChanged ? colors.orange : colors.grey600} size={14} weight={400}>{t('journeyDetails.location.platform')} 
        <TypographyStyles.BodyMSemibold 
          color={platformHasChanged ? colors.orange : colors.black} size={14} weight={600}> {platformToShow}
        </TypographyStyles.BodyMSemibold>
      </TypographyStyles.BodyMRegular>}
    </Container>
  )
}

export default Location;
